function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import useFollowThisProperty from './use-follow-this-property';
import useModalControl from './utils/use-modal-control';
var useFollowAnotherProperty = function useFollowAnotherProperty() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onCompleted = _ref.onCompleted;
  var _useModalControl = useModalControl(),
    modalProps = _useModalControl.modalProps,
    openModal = _useModalControl.openModal,
    closeModal = _useModalControl.closeModal;
  var _useFollowThisPropert = useFollowThisProperty({
      onCompleted
    }),
    openFollowThisProperty = _useFollowThisPropert.openFollowThisProperty,
    followThisPropertyProps = _useFollowThisPropert.followThisPropertyProps;
  var onAddressSelected = streetAddressId => {
    openFollowThisProperty(streetAddressId);
    closeModal();
  };
  var followAnotherPropertyProps = _objectSpread(_objectSpread({}, modalProps), {}, {
    onAddressSelected
  });
  return {
    openFollowAnotherProperty: openModal,
    followAnotherPropertyProps: followThisPropertyProps ? undefined : followAnotherPropertyProps,
    followThisPropertyProps
  };
};
export default useFollowAnotherProperty;